import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row, Button } from "react-bootstrap";

function Reason({ reason, setReason, setStep, hideModal }) {
  const reasons = [
    {
      id: 1,
      text: "Something was broken",
    },
    {
      id: 2,
      text: "I just don’t like it",
    },
    {
      id: 3,
      text: "I have privacy concern",
    },
    {
      id: 4,
      text: "Other",
    },
  ];

  return (
    <div className="reason">
      <Row>
        {reasons.map((item) => (
          <Col sm={6} className="item gutter-b" key={item.id}>
            <Card className="bordered pointer" onClick={() => setReason(item)}>
              <Card.Body>
                <p>{item.text}</p>

                <span className={item.id === reason.id ? "active" : ""}></span>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="actions">
        <div className="back" onClick={() => hideModal()}>
          Cancel
        </div>

        <Button variant="info" size="lg" disabled={!reason.id} onClick={() => setStep(2)}>
          Continue
        </Button>
      </div>
    </div>
  );
}

Reason.propTypes = {
  reason: PropTypes.object.isRequired,
  setReason: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default Reason;
